import { PathResponse } from "@repo/shared-types";
import { point } from "@turf/helpers";
import { nearestPointOnLine } from "@turf/nearest-point-on-line";
import { distance } from "@turf/distance";
import { length } from "@turf/length";
import { lineSlice } from "@turf/line-slice";

type PathWithGeoJson = Pick<PathResponse, "geoJson">;

export function calculatePathDistanceToCoordinates(
  path: PathWithGeoJson,
  coordinates: { lng: number; lat: number }
) {
  const feature = path.geoJson.features[0];

  const hoverPoint = point([coordinates.lng, coordinates.lat]);
  const closestPoint = point(
    feature.geometry.coordinates[
      nearestPointOnLine(feature, hoverPoint).properties.index
    ]
  );

  const distanceBetweenHoverPointAndClosestPoint = distance(
    closestPoint,
    hoverPoint
  );

  const pointsFromPathStart = lineSlice(
    feature.geometry.coordinates[0],
    closestPoint,
    feature
  );
  const pointsToPathEnd = lineSlice(
    closestPoint,
    feature.geometry.coordinates[feature.geometry.coordinates.length - 1],
    feature
  );

  const distanceFromStart =
    length(pointsFromPathStart) + distanceBetweenHoverPointAndClosestPoint;
  const distanceFromEnd =
    length(pointsToPathEnd) - distanceBetweenHoverPointAndClosestPoint;

  return { distanceFromStart, distanceFromEnd };
}
